<div class="edit-name-dialog">
  <div class="dialog-header">
    <div>{{ 'CUSTOM_OBJECTS.EDIT_NAME_DIALOG.TITLE' | translate }}</div>
  </div>

  <div class="dialog-content flex-col gap-8">
    <label>{{ 'CUSTOM_OBJECTS.EDIT_NAME_DIALOG.LABEL' | translate }}</label>
    <input
      class="ui-input"
      [(ngModel)]="newName"
      [placeholder]="'CUSTOM_OBJECTS.EDIT_NAME_DIALOG.PLACEHOLDER' | translate"
      (keyup.enter)="save()"
      autofocus
    />
  </div>

  <div class="dialog-footer">
    <ui-button
      type="default"
      [text]="'CUSTOM_OBJECTS.EDIT_NAME_DIALOG.CANCEL' | translate"
      (clickAction)="cancel()"
    >
    </ui-button>
    <ui-button
      type="primary"
      [text]="'CUSTOM_OBJECTS.EDIT_NAME_DIALOG.SAVE' | translate"
      [disabled]="!newName.trim()"
      (clickAction)="save()"
    >
    </ui-button>
  </div>
</div>
